module.exports = __webpack_public_path__ + "img/user1.cb57f764.png";